<template>
    <v-container>
        <v-row>
            <v-col cols="12">
                <v-simple-table dense>
                    <thead>
                        <tr>
                            <th>Producto</th>
                            <th class="item-number text-right">Precio</th>
                            <th class="item-number text-right">Descuento</th>
                            <th class="item-number text-right">Cantidad</th>
                            <th class="item-number text-right">Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in products" :key="item.id">
                            <td>{{ item.name }}</td>
                            <td class="text-right">{{ item.base_price | currency('S/') }}</td>
                            <td class="text-right">{{ item.discount_value | currency('S/') }}</td>
                            <td class="text-right">{{ item.quantity }}</td>
                            <td class="text-right">{{ item.subtotal | currency('S/') }}</td>
                        </tr>                        
                    </tbody>
                    <tfoot>
                        <tr>
                            <td colspan="3" class="foot-purchase"></td>
                            <td class="font-weight-medium">Subtotal</td>
                            <td class="text-right">{{ order.subtotal | currency('S/') }}</td>
                        </tr>
                        <tr>
                            <td colspan="3" class="foot-purchase"></td>                          
                            <td class="font-weight-medium">IGV</td>
                            <td class="text-right">{{ order.igv | currency('S/') }}</td>
                        </tr>
                        <tr>
                            <td colspan="3" class="foot-purchase"></td>
                            <td class="font-weight-medium">Total</td>
                            <td class="text-right">{{ order.total | currency('S/') }}</td>
                        </tr>
                    </tfoot>

                </v-simple-table>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>

export default {
    name: 'OrdersDetail',
    props: ['order', 'products'],
    methods: {
        calculateDiscount(base_price, porcent) {
            let discount = 0
            discount = base_price * (porcent / 100)

            return discount
        }
    }
}
</script>

<style scoped>
.item-number{
    width: 150px !important;
    min-width: 150px !important;
}

.foot-purchase{
    border-bottom: 0px !important;
}
</style>